import { gsap } from 'gsap'

export default class CursorEffectAction {
    static #cursor = "[data-id='iris-cursor']"
    static #cursorSvg = "[data-id='iris-cursor-svg']"
    static #cursorPointer = "[data-id='iris-cursor-pointer']"
    static #cursorArrowRight = "[data-id='iris-cursor-arrow-right']"
    static #cursorArrowLeft = "[data-id='iris-cursor-arrow-left']"

    static linkTrigger =
        'a:not(.stretched-link):not([data-cursor="drag"] *), ' +
        '[data-obf-target], ' +
        '[data-cursor="hover"], ' +
        '.fancybox__container .carousel__button,' +
        'button,' +
        '[data-hc-collapse-trigger]'

    static sliderTrigger =
        '.hc-slider-initialized:not(.hc-slider-lock):not([data-hc-slider-arrows]):not([data-hc-slider-pagination]):not([data-cursor="no-drag"]),' +
        '[data-cursor="drag"]'

    constructor() {
        CursorEffectAction.init()
        CursorEffectAction.onMove()
        CursorEffectAction.onInOut()
        CursorEffectAction.onSlider()
        CursorEffectAction.onLink()
        CursorEffectAction.onCard()
        CursorEffectAction.onIframe()
    }

    static init() {
        gsap.set(CursorEffectAction.#cursor, {
            xPercent: -50,
            yPercent: -50,
            opacity: 0,
        })

        gsap.set(CursorEffectAction.#cursorArrowRight, {
            opacity: 0,
        })

        gsap.set(CursorEffectAction.#cursorArrowLeft, {
            opacity: 0,
        })
    }

    static onMove() {
        //Mouse moove effects
        $(document).on('mousemove', (e) => {
            gsap.to(CursorEffectAction.#cursor, {
                duration: 0.1,
                opacity: 1,
                x: e.clientX,
                y: e.clientY,
            })
        })
    }

    static onInOut() {
        //Mouse enter effects
        $(document).mouseleave(() => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                opacity: 0,
                duration: 0.2,
            })
        })

        //Mouse leave effects
        $(document).mouseenter(() => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                opacity: 1,
                duration: 0.2,
            })
        })
    }

    static onSlider() {
        //Slider
        //Mouse enter effects
        $(document).on('mouseenter', CursorEffectAction.sliderTrigger, () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                scale: 4.8,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorPointer, {
                opacity: 0.85,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorArrowRight, {
                opacity: 1,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorArrowLeft, {
                opacity: 1,
                duration: 0.2,
            })
            $(CursorEffectAction.#cursor).addClass('iris-cursor--hover-slider')
        })

        //Mouse leave effects
        $(document).on('mouseleave', CursorEffectAction.sliderTrigger, () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                scale: 1,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorPointer, {
                opacity: 1,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorArrowRight, {
                opacity: 0,
                duration: 0.2,
            })

            gsap.to(CursorEffectAction.#cursorArrowLeft, {
                opacity: 0,
                duration: 0.2,
            })
            $(CursorEffectAction.#cursor).removeClass('iris-cursor--hover-slider')
        })

        //Slider lock / pagination / arrows
        //Mouse enter effects
        $(document).on(
            'mouseenter',
            '[data-hc-slider-arrows] .iris-card, [data-hc-slider-pagination] .iris-card, .hc-slider-lock .iris-card',
            () => {
                gsap.to(CursorEffectAction.#cursorSvg, {
                    scale: 2.6,
                    duration: 0.2,
                })
                $(CursorEffectAction.#cursor).addClass('iris-cursor--hover-link')
            },
        )

        //Mouse leave effects
        $(document).on(
            'mouseleave',
            '[data-hc-slider-arrows] .iris-card, [data-hc-slider-pagination] .iris-card, .hc-slider-lock .iris-card',
            () => {
                gsap.to(CursorEffectAction.#cursorSvg, {
                    scale: 1,
                    duration: 0.2,
                })
                $(CursorEffectAction.#cursor).removeClass('iris-cursor--hover-link')
            },
        )
    }

    static onLink() {
        //Mouse enter effects
        $(document).on('mouseenter', CursorEffectAction.linkTrigger, (element) => {
            let parent = element.target.parentNode
            let isNotInSlider = true
            while (parent) {
                if (
                    $(parent).hasClass('hc-slider-initialized') ||
                    $(parent).attr('data-cursor') === 'drag'
                ) {
                    isNotInSlider = false
                }
                parent = parent.parentNode
            }

            if (isNotInSlider) {
                gsap.to(CursorEffectAction.#cursorSvg, {
                    scale: 2.6,
                    duration: 0.2,
                })
                $(CursorEffectAction.#cursor).addClass('iris-cursor--hover-link')
            }
        })

        //Mouse leave effects
        $(document).on('mouseleave', CursorEffectAction.linkTrigger, (element) => {
            let parent = element.target.parentNode
            let isNotInSlider = true
            while (parent) {
                if (
                    $(parent).hasClass('hc-slider-initialized') ||
                    $(parent).attr('data-cursor') === 'drag'
                ) {
                    isNotInSlider = false
                }
                parent = parent.parentNode
            }

            if (isNotInSlider) {
                gsap.to(CursorEffectAction.#cursorSvg, {
                    scale: 1,
                    duration: 0.2,
                })
                $(CursorEffectAction.#cursor).removeClass('iris-cursor--hover-link')
            }
        })
    }

    static onCard() {
        //Mouse enter effects
        $(document).on('mouseenter', '.iris-card:not(.swiper-slide)', () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                scale: 2.6,
                duration: 0.2,
            })
            $(CursorEffectAction.#cursor).addClass('iris-cursor--hover-link')
        })

        //Mouse leave effects
        $(document).on('mouseleave', '.iris-card:not(.swiper-slide)', () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                scale: 1,
                duration: 0.2,
            })
            $(CursorEffectAction.#cursor).removeClass('iris-cursor--hover-link')
        })
    }

    static onIframe() {
        //Mouse enter effects
        $(document).on('mouseenter', 'iframe', () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                opacity: 0,
                duration: 0.2,
            })
        })

        //Mouse leave effects
        $(document).on('mouseleave', 'iframe', () => {
            gsap.to(CursorEffectAction.#cursorSvg, {
                opacity: 1,
                duration: 0.2,
            })
        })
    }
}
